import { Component, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { TipoDescuento } from 'src/app/global/enums/tipo-descuento.enum';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { ACTIONS, DialogResult } from 'src/app/global/models/dialog/dialog-data';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { IProductComponent } from 'src/app/view-model/components/shopping-cart/iproduct-component';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { environment } from '../../../../../environments/environment.prod';
const env = environment;

@Component({
  selector: 'app-base-product',
  templateUrl: './base-product.component.html',
  styleUrls: ['./base-product.component.scss']
})
export class BaseProductComponent implements IProductComponent, OnInit {
  isClicked = false;
  active: boolean;
  CodigoProductoEnum = CodigoProductoEnum;
  product: Product;
  test = '1233.44';
  screenSize: number;
  distanciaOk = false;
  distancia: boolean;
  container = true;
  desplegarValores = true;
  cantidades: Array<number>;
  dataRubro: any;
  bloquearCantidad = false;
  aplicarDescuento: Subscription;
  descuentoActivo = false;
  removerDescuento: Subscription;

  //Calculo de precio
  cantidadSeleccionada: number;
  valorTotalEnPesos: number;
  valorTotalEnUF: number;
  valorUFNow: number; //viene del servicio
  valorDescuento: number;
  codigoDescuento: String;

  valorPrecioGarantia:number;
  valorPrecioProductoSinGarantia:number;

  valorPrecioOferta:number;
  labelPrecioOferta:string;
  labelPrecio:string;

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth;
  }

  constructor(
    protected carroComprasService: CarroComprasService,
    protected marketplaceRedirectService: MarketplaceRedirectService,
    protected dialogService: DialogService,
    protected storageServ: LocalStorageService,
    protected tagM: TagManagerService,
    protected productoServiceVM: vmProductosService,
    protected localStorageService: LocalStorageService
  ) {
    this.aplicarDescuento = this.carroComprasService.aplicarDescuento$.subscribe((descuento: any) => {
      let valorSinIVA;
      if (descuento) {
        this.descuentoActivo = true;
        this.codigoDescuento = descuento.codigo;
        switch (descuento.tipoDescuento) {
          case TipoDescuento.PORCENTUAL:
            this.valorDescuento = Math.floor(Number.parseFloat(this.product.amount.replace('.', '')) * descuento.valorDescuento / 100);
            this.valorTotalEnPesos =  Math.round(Number.parseFloat(this.product.amount.replace('.', '')) - this.valorDescuento);
            valorSinIVA = this.valorTotalEnPesos / 1.19;
            this.valorTotalEnUF = Math.fround((valorSinIVA / this.product.valorRealUf));
            break;
          case TipoDescuento.ABSOLUTO:
            /** this.cantidadSeleccionada = 0 cuando producto no tiene selector de cantidad (WIX) */
            this.valorDescuento =  Math.floor(descuento.valorDescuento * (this.cantidadSeleccionada > 0 ? this.cantidadSeleccionada : 1));
            this.valorTotalEnPesos =  Math.round(Number.parseFloat(this.product.amount.replace('.', '')) - this.valorDescuento);
            /* Si el valor a pagar es inferior a 50 pesos se fija valor en 50 pesos dado que es el mínimo aceptado por Webpay. */
            if (this.valorTotalEnPesos < 50) {
              /** Advertencia al usuario respecto al valor a pagar una vez aplicado el descuento. */
              (<any>$('#maxDiscountApplied.toast')).toast('show');
              this.valorTotalEnPesos = 50;
            }
            valorSinIVA = this.valorTotalEnPesos / 1.19;
            this.valorTotalEnUF = Math.fround((valorSinIVA / this.product.valorRealUf));
            break;
          default:
            console.log("error");
            break;
        }
        this.updateDiscountCodeOnLocalStorage(descuento);
      }
    })

    this.removerDescuento = this.carroComprasService.removerDescuento$.subscribe((removerDescuento: boolean) => {
      if (removerDescuento) {
        this.descuentoActivo = false;
        this.codigoDescuento = null;
        this.updateDiscountCodeOnLocalStorage();
        this.refreshData();
      }
    })
  }

  ngOnInit(): void {
    this.productoServiceVM.obtenerValorUF().subscribe((resp: any) => {
      this.valorUFNow = resp.uf;
      this.product.valorRealUf = resp.uf;
      this.screenSize = window.innerWidth;
      this.cantidadSeleccionada = Number(this.product.cantidad);
      this.refreshData();
      this.distanciaOk = true;
      if (this.product && this.product.codigoProducto === 'INTEGRADOR_CLIENTE') {
        this.desplegarValores = false;
      }

      this.carroComprasService.changeCantidad$.subscribe((resp: boolean) => {
        if (resp) {
          this.actCantidades();
          this.refreshData();
        } else {
          this.cantidades = this.product.rangoCantidades;
        }
      });

      this.carroComprasService.changePaso$.subscribe((paso: string) => {
        if (paso === 'P_3' || paso === 'RESUMEN') {
          this.bloquearCantidad = true;
          this.product.isOpen = true;
        } else {
          this.bloquearCantidad = false;
        }
      });

      if (this.screenSize < 1200) {
        this.carroComprasService.hide();
      } else {
        this.carroComprasService.show();
      }
    }, (error) => {
      console.error(error);
      this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, reintente.');
      this.tagM.logError('Paso 1', error.statusText, error.message);
    }, () => {
      this.checkDiscountCode();
    });
  }

  checkDiscountCode() {
    let step3Data = this.localStorageService.getPaso3();
    if (step3Data && step3Data.codigoDescuento) {
      this.carroComprasService.aplicarDescuento(step3Data.codigoDescuento);
    } else {
      console.warn("No hay datos disponibles o código de descuento es inválido.");
    }
  }
  

  private actCantidades() {
    this.cantidades = [1, 2, 3];
    if (this.cantidadSeleccionada > 3) {
      this.cantidadSeleccionada = 3;
    }
  }

  get esProductoEnVenta(): boolean {
    return this.product.etiquetaVenta;
  }

  get esProductoEnArriendo(): boolean {
    return !this.product.etiquetaVenta;
  }

  get valorUf(): number {
    return this.valorTotalEnUF;
  }

  get valorProductoPeso() {
    return this.valorTotalEnPesos;
  }

  get amountUf(): string {
    return this.valorTotalEnUF.toFixed(2);
  }

  get valorPrecioOfertaPesos(): string {
    if(this.valorPrecioOferta != undefined){
      return this.valorPrecioOferta.toString();
    }
  }

  private refreshData(): void {
    let valorSinIVA:number;
    if (this.product && this.product.codigoProducto !== 'CREACION_SITIO_ALIANZA_WIX' && this.product.codigoProducto !== 'INTEGRADOR_TRANSBANK' && this.product.codigoProducto !== 'LINK_PAGO') {
      if (this.product.moneda === 'UF') {
        this.valorTotalEnUF = Number.parseFloat(this.product.amountUF.replace(',', '.')) / Number(this.product.cantidad) * this.cantidadSeleccionada;
        this.valorTotalEnPesos = Math.round(this.valorTotalEnUF * this.valorUFNow * 1.19);
      } else {
        this.valorTotalEnPesos = Number.parseFloat(this.product.amount.replace('.', '')) / Number(this.product.cantidad) * this.cantidadSeleccionada;
        valorSinIVA = Number(this.valorTotalEnPesos / 1.19);
        this.valorTotalEnUF = Number(valorSinIVA / this.product.valorRealUf);
      }
      this.product.amount = String(Intl.NumberFormat('es-CL').format(this.valorTotalEnPesos));
      this.product.amountUF = String(Intl.NumberFormat('es-CL').format(Number(this.valorTotalEnUF.toFixed(2))));
      this.product.cantidad = this.cantidadSeleccionada.toString();

      //Viaje de precio oferta y label en Trolley
      if(this.product.amountOfferPrice){
        this.valorPrecioOferta = Number(this.product.amountOfferPrice) * Number(this.product.cantidad);
        this.labelPrecio = this.product.leyendaPrecio;
        this.labelPrecioOferta = this.product.leyendaPrecioOferta;
      }
      if(this.product.garantia != undefined && this.product.garantia.tieneGarantia){
        this.valorPrecioGarantia= this.product.garantia.valores.totalGarantias / Number(this.product.garantia.valores.cantidadEquipos) * this.cantidadSeleccionada;
        this.valorPrecioProductoSinGarantia= this.product.garantia.valores.totalProductos / Number(this.product.garantia.valores.cantidadEquipos) * this.cantidadSeleccionada;
      }
    }
    this.carroComprasService.products[0] = this.product;
    //this.carroComprasService.changeValorCantidad(this.cantidadSeleccionada);
  }

  toggle(): void {
    this.distanciaOk = !this.distanciaOk;
    this.product.isOpen = !this.product.isOpen;
    this.isClicked = !this.isClicked;
    this.container = !this.container;
  }

  deleteProduct(): void {

    if (this.screenSize < 960) {
      this.carroComprasService.hide();
    }
    const dialogRef = this.dialogService.openDeleteProductDialog(this.product);
    dialogRef.afterClosed().subscribe((dialogResult: DialogResult) => {
      if (dialogResult && dialogResult.action === ACTIONS.OK) {
        this.tagM.logEliminarProducto(this.product);
        this.carroComprasService.removeProduct(this.product);
        this.marketplaceRedirectService.redirect();
      } else {
        if (this.screenSize < 960) {
          this.carroComprasService.show();
        }
      }
    });

  }

  updateDiscountCodeOnLocalStorage(descuento?: any) {
    let step3Data: Paso3 = this.localStorageService.getPaso3();
    if (descuento) {
      step3Data.codigoDescuento = {
        codigo: descuento.codigo,
        tipoDescuento: descuento.tipoDescuento,
        valorDescuento: descuento.valorDescuento
      }
    } else if(step3Data.codigoDescuento){
      delete step3Data.codigoDescuento;
    }

    this.localStorageService.setPaso3(step3Data);
  }
}
